// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\ScheduleDate\ApiScheduleDateEntity.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Change, ChangeData, ChangeOptions } from 'data/models/Change';
import { CoordinationCard, CoordinationCardData, CoordinationCardOptions } from 'data/models/CoordinationCard';
import { Issue, IssueData, IssueOptions } from 'data/models/Issue';
import { ItineraryPoint, ItineraryPointData, ItineraryPointOptions } from 'data/models/ItineraryPoint';
import { JobOrder, JobOrderData, JobOrderOptions } from 'data/models/JobOrder';
import { MilestoneType, MilestoneTypeData, MilestoneTypeOptions } from 'data/models/MilestoneType';
import { PortCall, PortCallData, PortCallOptions } from 'data/models/PortCall';
import { ScheduleDateEvent, ScheduleDateEventData, ScheduleDateEventOptions } from 'data/models/ScheduleDateEvent';
import { ScheduleDateSelf, ScheduleDateSelfData, ScheduleDateSelfOptions } from 'data/models/ScheduleDateSelf';
import { ScheduleDateVersion, ScheduleDateVersionData, ScheduleDateVersionOptions } from 'data/models/ScheduleDateVersion';

// ScheduleDateEntityData is the class that ScheduleDateEntity serializes to/from
export interface ScheduleDateEntityData {
    Id : number;
	
    Change : ChangeData | null;
    ChangeId : number;
    CoordinationCards : CoordinationCardData[] | null;
    Events : ScheduleDateEventData[] | null;
    Issues : IssueData[] | null;
    ItineraryPoint : ItineraryPointData | null;
    ItineraryPointId : number;
    JobOrder : JobOrderData | null;
    JobOrderId : number;
    MilestoneType : MilestoneTypeData | null;
    MilestoneTypeId : number | null;
    PortCall : PortCallData | null;
    PortCallId : number;
    Self : ScheduleDateSelfData | null;
    Version : ScheduleDateVersionData | null;
	
    Type : string | null;
}

// ScheduleDateEntityOptions is the class which may be passed to the ScheduleDateEntity constructor to define optional initial data values
export interface ScheduleDateEntityOptions {
    Id : number;
	
    Change? : ChangeOptions | null;
    ChangeId? : number;
    CoordinationCards? : CoordinationCardOptions[] | null;
    Events? : ScheduleDateEventOptions[] | null;
    Issues? : IssueOptions[] | null;
    ItineraryPoint? : ItineraryPointOptions | null;
    ItineraryPointId? : number;
    JobOrder? : JobOrderOptions | null;
    JobOrderId? : number;
    MilestoneType? : MilestoneTypeOptions | null;
    MilestoneTypeId? : number | null;
    PortCall? : PortCallOptions | null;
    PortCallId? : number;
    Self? : ScheduleDateSelfOptions | null;
    Version? : ScheduleDateVersionOptions | null;
	
    Type? : string | null;
}

export class ScheduleDateEntity {
    public Id : DataSignal<number>;
	
    public Change : DataSignal<Change | null>;
    public ChangeId : DataSignal<number>;
    public CoordinationCards : SDataArray<CoordinationCard>;
    public Events : SDataArray<ScheduleDateEvent>;
    public Issues : SDataArray<Issue>;
    public ItineraryPoint : DataSignal<ItineraryPoint | null>;
    public ItineraryPointId : DataSignal<number>;
    public JobOrder : DataSignal<JobOrder | null>;
    public JobOrderId : DataSignal<number>;
    public MilestoneType : DataSignal<MilestoneType | null>;
    public MilestoneTypeId : DataSignal<number | null>;
    public PortCall : DataSignal<PortCall | null>;
    public PortCallId : DataSignal<number>;
    public Self : DataSignal<ScheduleDateSelf | null>;
    public Version : DataSignal<ScheduleDateVersion | null>;
	
    public Type : DataSignal<string | null>;

    constructor();
    constructor(data : ScheduleDateEntityOptions);
    constructor(data: ScheduleDateEntityOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Change = S.value<Change | null>(null);
        this.ChangeId = jsonableObservable(S.value<number>(data && data.ChangeId !== undefined ? data.ChangeId : 0));
        this.CoordinationCards = SArray<CoordinationCard>([]);
        this.Events = SArray<ScheduleDateEvent>([]);
        this.Issues = SArray<Issue>([]);
        this.ItineraryPoint = S.value<ItineraryPoint | null>(null);
        this.ItineraryPointId = jsonableObservable(S.value<number>(data && data.ItineraryPointId !== undefined ? data.ItineraryPointId : 0));
        this.JobOrder = S.value<JobOrder | null>(null);
        this.JobOrderId = jsonableObservable(S.value<number>(data && data.JobOrderId !== undefined ? data.JobOrderId : 0));
        this.MilestoneType = S.value<MilestoneType | null>(null);
        this.MilestoneTypeId = jsonableObservable(S.value<number | null>(data && data.MilestoneTypeId !== undefined ? data.MilestoneTypeId : null));
        this.PortCall = S.value<PortCall | null>(null);
        this.PortCallId = jsonableObservable(S.value<number>(data && data.PortCallId !== undefined ? data.PortCallId : 0));
        this.Self = S.value<ScheduleDateSelf | null>(null);
        this.Version = S.value<ScheduleDateVersion | null>(null);
	    
        this.Type = jsonableObservable(S.value<string | null>(data && data.Type !== undefined ? data.Type : null));
    }

    static key(obj : ScheduleDateEntity) {
        return obj.Id();
    }
    
    static dataKey(obj : ScheduleDateEntityOptions) {
        return obj.Id;
    }

    static update(obj : ScheduleDateEntity, data : ScheduleDateEntityOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.ChangeId !== undefined) obj.ChangeId(data.ChangeId);
            if (data.ItineraryPointId !== undefined) obj.ItineraryPointId(data.ItineraryPointId);
            if (data.JobOrderId !== undefined) obj.JobOrderId(data.JobOrderId);
            if (data.MilestoneTypeId !== undefined) obj.MilestoneTypeId(data.MilestoneTypeId);
            if (data.PortCallId !== undefined) obj.PortCallId(data.PortCallId);
	        
            if (data.Type !== undefined) obj.Type(data.Type);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/ScheduleDateEntity.ts